import { Path, Shape } from "three";
import { archNotch } from "../geometry/arch";
import { straightRun } from "../geometry/path";
import { ARCH_RADIUS, CAR, FRONT_AXLE_X, NOSE_X, REAR_AXLE_X, TAIL_X } from "./dimensions";
function lowerBodyProfile() {
  const { sillY, beltlineY, wheelRadius } = CAR;
  const s = new Shape();
  s.moveTo(TAIL_X + 0.11, sillY);
  for (const axleX of [REAR_AXLE_X, FRONT_AXLE_X]) {
    archNotch(s, { axleX, hubY: wheelRadius, radius: ARCH_RADIUS, edgeY: sillY });
  }
  straightRun(s, NOSE_X - 0.12, sillY);
  s.quadraticCurveTo(NOSE_X, sillY + 0.02, NOSE_X, 0.56);
  s.quadraticCurveTo(NOSE_X + 5e-3, 0.71, NOSE_X - 0.12, 0.78);
  s.quadraticCurveTo(1.82, 0.9, 1.34, beltlineY);
  straightRun(s, -1.84, beltlineY, 0.012);
  s.quadraticCurveTo(TAIL_X + 0.03, beltlineY - 0.02, TAIL_X + 0.02, 0.74);
  s.quadraticCurveTo(TAIL_X - 5e-3, 0.5, TAIL_X + 0.05, 0.4);
  straightRun(s, TAIL_X + 0.11, sillY);
  return s;
}
const traceGlasshouse = (path) => {
  path.moveTo(-1.74, 0.9);
  straightRun(path, 1.3, 0.9);
  path.quadraticCurveTo(0.86, 1.3, 0.44, 1.42);
  path.quadraticCurveTo(0, 1.468, -0.55, 1.458);
  path.quadraticCurveTo(-0.95, 1.45, -1.3, 1.24);
  path.quadraticCurveTo(-1.62, 1.06, -1.74, 0.9);
};
const traceDaylightOpening = (path) => {
  path.moveTo(-1.585, 0.985);
  straightRun(path, 1.165, 0.985);
  path.quadraticCurveTo(0.845, 1.24, 0.505, 1.335);
  path.quadraticCurveTo(0, 1.382, -0.55, 1.372);
  path.quadraticCurveTo(-0.925, 1.364, -1.235, 1.172);
  path.quadraticCurveTo(-1.5, 1.02, -1.585, 0.985);
};
const traceGlassLine = (path) => {
  path.moveTo(-1.663, 0.943);
  straightRun(path, 1.233, 0.943);
  path.quadraticCurveTo(0.853, 1.27, 0.473, 1.378);
  path.quadraticCurveTo(0, 1.425, -0.55, 1.415);
  path.quadraticCurveTo(-0.938, 1.407, -1.268, 1.206);
  path.quadraticCurveTo(-1.56, 1.04, -1.663, 0.943);
};
function glassShellProfile() {
  const s = new Shape();
  traceGlassLine(s);
  return s;
}
function glasshouseFrameProfile() {
  const s = new Shape();
  traceGlasshouse(s);
  const opening = new Path();
  traceDaylightOpening(opening);
  s.holes.push(opening);
  return s;
}
export {
  glassShellProfile,
  glasshouseFrameProfile,
  lowerBodyProfile
};
